if (!customElements.get('quickbuy-variant-radios')) {
  class QuickbuyVariantRadios extends VariantSelects {
    constructor() {
      super();
      this.dataset.updateUrl = false;
      this.dataset.updateSwatch = false;
      this.dataset.updateVariantTitle = true;

      this.querySelector('.quickbuy-form__show-more-variants').addEventListener('click', this.toggleMoreVariants)
    }
    
    formatPrice(price){
      return `₱${(price / 100).toLocaleString()}`
    }
    
    createButtonPriceHTML(price, compareAtPrice){
      if(price && compareAtPrice){
        return `
          <span class="price price--compare-at-price">${this.formatPrice(compareAtPrice)}</span>
          <span class="price">${this.formatPrice(price)}</span>
        `
      }else if(price){
        return `<span class="price">${this.formatPrice(price)}</span>`
      }
      return ''
    }
    
    renderProductInfo(){
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=product-info-api`)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(responseText, "text/html");
        const productInfo = JSON.parse(htmlDocument.documentElement.querySelector("#product-info-api").textContent)
        const priceWrapper = this.closest(".quickbuy-form").querySelector(".price-wrapper")
        const compareAtPriceElement = this.closest(".quickbuy-form").querySelector(".price-wrapper [class='price price--compare-at-price']")
        
        // Update price
        priceWrapper.innerHTML = this.createButtonPriceHTML(productInfo.price, productInfo.compare_at_price)       
      })
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }

    toggleMoreVariants(e) {
      e.preventDefault();
      let cardInfo = this.closest('.card-information')
      let variantContainer = cardInfo.querySelector('quickbuy-variant-radios fieldset')
      variantContainer.classList.toggle('active')
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const newMedia = document.querySelectorAll(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `QuickBuy-MediaGallery-${this.dataset.section}`
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;
        });

      if (!newMedia) return;
      newMedia.forEach((media) => {
        const parent = media.parentElement;

        // move variant featured image to top
        parent.prepend(media);

        // make new featured variant image the active image
        media.classList.add('active')
      })
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#${this.dataset.productFormId}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  customElements.define('quickbuy-variant-radios', QuickbuyVariantRadios);
}
